var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('appHeader'),_c('div',{staticClass:"container-fluid add-client"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-sm-12 pr-0 dark-bg"},[_c('appAdminSidebar')],1),_c('router-view')],1)]),_c('appFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }